import React from 'react';
import * as Blueprint from "@blueprintjs/core";
import * as BlueprintDatetime from "@blueprintjs/datetime";
import * as BlueprintDatetime2 from "@blueprintjs/datetime2";
import * as BlueprintSelect from "@blueprintjs/select";
import * as ReactRedux from "react-redux";
import { createRoot } from 'react-dom/client';
import * as ReactDOMClient from 'react-dom/client';
import ReactDOM from 'react-dom';
import App from './App';
import AppExtension from './AppExtension';
import { Provider } from 'react-redux';
import { store, persistor } from './configure-store';
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import Loading from './modules/session/Loading';
import * as DataTable from 'ag-grid-react';
import * as agGridCommunity from 'ag-grid-community';
// import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import * as serviceWorker from './serviceWorker';
import * as Dockview from 'dockview';
import * as SplitPaneReact from 'react-split-pane';
import {
	createBrowserRouter,
	RouterProvider,
	Route,
	Link,
  } from "react-router-dom";
import Markdown from 'react-markdown'
import rehypeHighlight from 'rehype-highlight';
import rehypeRaw from 'rehype-raw';
import * as axios from 'axios';
import * as MonacoEditor from 'monaco-editor';
import * as ReactMonacoEditor from 'react-monaco-editor';

import 'bootstrap/dist/css/bootstrap.min.css';
import './app.css';

//Blueprintjs
import 'normalize.css/normalize.css'
import '@blueprintjs/core/lib/css/blueprint.css'
import '@blueprintjs/icons/lib/css/blueprint-icons.css'
import 'reflect-metadata';
import '@blueprintjs/datetime/lib/css/blueprint-datetime.css';
import '@blueprintjs/datetime2/lib/css/blueprint-datetime2.css';
import '@blueprintjs/select/lib/css/blueprint-select.css';

//aggrid css 
// import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

import { applyTheme, getStoredTheme } from './modules/layoutv2/theme';

// Apply persisted theme before first paint (Blueprint bp5-dark on body)
applyTheme(getStoredTheme());

// Icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLock, faAt, faSpinner, faHome, faPlug, faCog, faDownload,
	faQuestionCircle, faUser, faSitemap, faWrench, faPuzzlePiece,faSync,
	faStopCircle, faUniversity, faCogs, faPowerOff, faArrowRight, faList,
	faChartArea, faBrain, faGem, faUserMd, faGlobeAfrica, faPeopleCarry,
	faFolder, faFile, faStar, faChevronRight, faDotCircle, faFolderOpen,
	faLink, faClock, faRss, faChartLine, faSquare, faTable, faInfoCircle
	,faAsterisk, faFileAlt,faFrown,faDatabase, faFileExcel, faFileCsv,
	faBroadcastTower, faPencilRuler, faBook,faCloudUploadAlt,faTools,
	faCandyCane,faHatWizard, faGlobe, faEllipsisH, faCode, faBolt, faSlidersH,
	faPlay, faPlayCircle, faPause, faStop, faStepForward, faStepBackward, faFastForward,
	faProjectDiagram
} from '@fortawesome/free-solid-svg-icons'

import { faTwitter, faFacebook, faInstagram, faYoutube, faGithub, faGoogle, faLinkedin } from '@fortawesome/free-brands-svg-icons';

library.add(faLock, faAt, faSpinner, faHome, faPlug, faCog, faDownload,
faQuestionCircle, faUser, faSitemap, faWrench, faPuzzlePiece,faSync,
faStopCircle, faUniversity, faCogs, faPowerOff, faArrowRight, faList,
faChartArea, faBrain, faGem, faUserMd, faGlobeAfrica, faPeopleCarry,
faFolder, faFile, faStar, faChevronRight, faDotCircle, faFolderOpen, 
faLink, faClock, faRss, faChartLine, faSquare, faTable, faInfoCircle,
faAsterisk, faFileAlt,faFrown, faDatabase, faFileExcel, faFileCsv,
faBroadcastTower, faPencilRuler, faBook, faCloudUploadAlt, faTools, 
faCandyCane, faHatWizard, faGlobe, faEllipsisH, faCode, faBolt, faSlidersH,
faGithub, faTwitter, faFacebook, faInstagram, faYoutube, faGoogle, faLinkedin);



//Google Auth 
window.GOOGLE_CLIENT_ID = '553066422187-e2th3pc8o383mqbnea6hendbj5ur8rir.apps.googleusercontent.com';

//desktop google client id
window.GOOGLE_CLIENT_ID_DESKTOP = '553066422187-026u9e4e1c5gadtuaq13q2gcvjognguj.apps.googleusercontent.com';

// Register all Community features
// ModuleRegistry.registerModules([AllCommunityModule]);

//Add to window for use with extensions
//-------------------------------------
window.react = React;
window["react-dom"] = ReactDOM;
window["react-dom/client"] = ReactDOMClient;
window["react-redux"] = ReactRedux;
window["@blueprintjs/core"] = Blueprint;
window["@blueprintjs/datetime"] = BlueprintDatetime;
window["@blueprintjs/datetime2"] = BlueprintDatetime2;
window["@blueprintjs/select"] = BlueprintSelect;
window["react-redux"] = ReactRedux;
window['redux-store'] = store;
window['ag-grid-react'] = DataTable;
window['ag-grid-community'] = agGridCommunity;
window['dockview'] = Dockview;
window['react-split-pane'] = SplitPaneReact;
window['react-markdown'] = Markdown;
window['rehype-highlight'] = rehypeHighlight;
window['rehype-raw'] = rehypeRaw;
window['axios'] = axios;
window['monaco-editor'] = MonacoEditor;
window['react-monaco-editor'] = ReactMonacoEditor;
//-------------------------------------


//exntesion
window['BODAPRO_EXTENSIONS'] = [];
//will hold the rxjs events
window.commands$ = {};
const root = createRoot(document.getElementById('root'));
// root.render(
// 	<Provider store={store} key="provider">
// 		<PersistGate loading={<Loading show={true}/>} persistor={persistor}>
// 			<App persistor={persistor}/>
// 		</PersistGate>
// 	</Provider>
// );


const router = createBrowserRouter([
	{
	  path: "/extensions/:extension",
	  element: (
		<Provider store={store} key="provider">
		  <PersistGate loading={<Loading show={true}/>} persistor={persistor}>
			  <AppExtension persistor={persistor}/>
		  </PersistGate>
		</Provider>),
	},
	{
	  path: "*",
	  element: (
	  	<Provider store={store} key="provider">
			<PersistGate loading={<Loading show={true}/>} persistor={persistor}>
				<App persistor={persistor}/>
			</PersistGate>
  		</Provider>),
	},
  ]);
root.render(<RouterProvider router={router} />);

	

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
